import { useTelesalesModule } from "./data/hooks/useTelesalesModule"

export const useTelesalesVideoUrlParam = (): string | null => {
    const telesalesModule = useTelesalesModule()

    return telesalesModule?.parameters?.find((x) => x.key === "URL_Video")?.value || null
}
